import * as yup from 'yup';

import { BaseYup, MAX_INPUT } from "@/config/baseYup";

export const userManagementSearchFormSchema = BaseYup.object({
  keyword: BaseYup.string().max(MAX_INPUT),
  start_date: BaseYup.date().nullable(),
  end_date: BaseYup.date().nullable(),
});

export type UserManagementSearchFormType = yup.InferType<typeof userManagementSearchFormSchema>;